import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../components/Loading/Lazy';

const HistoryLoadable = loadable(() => import(/* webpackChunkName: "history-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default HistoryLoadable;
